import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
import { listReports, resolveReport, messageErrorKey } from '../utils/privateMessages.mjs';

const t = key => app.translator.trans(`yingtao-forum-homepage.forum.private_messages.${key}`);

export default class MessageReportsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.alive = true;
    this.rows = [];
    this.notes = {};
    this.offset = 0;
    this.generation = 0;
    if (app.forum.attribute('canReviewMessages')) this.load();
  }

  onremove(vnode) {
    this.alive = false;
    this.generation++;
    super.onremove(vnode);
  }

  async load() {
    const token = ++this.generation;
    this.loading = true;
    try {
      const rows = await listReports(app, 50, this.offset);
      if (!this.alive || token !== this.generation) return;
      this.rows = rows;
      this.error = null;
    } catch (error) {
      if (this.alive && token === this.generation) this.error = messageErrorKey(error);
    } finally {
      if (this.alive && token === this.generation) { this.loading = false; m.redraw(); }
    }
  }

  async resolve(row, action) {
    if (this.busy) return;
    const token = this.generation;
    this.busy = row.id;
    try {
      await resolveReport(app, row.id, action, this.notes[row.id]);
      if (this.alive && token === this.generation) await this.load();
    } catch (error) {
      if (this.alive && token === this.generation) this.error = messageErrorKey(error);
    } finally { if (this.alive) { this.busy = null; m.redraw(); } }
  }

  view() {
    if (!app.forum.attribute('canReviewMessages')) return m('div.container', t('permission_error'));
    return m('div.container.MessageReportsPage', [m('h1', t('review_nav')),
      Button.component({ className: 'Button', disabled: !!this.busy, onclick: () => this.load() }, t('retry')),
      this.error && m('div.Alert.Alert--error', { role: 'alert' }, t(this.error)),
      this.loading && LoadingIndicator.component(),
      !this.rows.length && m('p', t('empty_reports')),
      this.rows.map(row => m('article.MessageReview', { key: row.id, id: `message-report-${row.id}` }, [
        m('h2', `${row.message.sender.nickname} · ${row.reporter.nickname}`),
        m('span', t(`status_${row.status}`)), m('time', row.created_at),
        m('p.MessageBody', row.message.body), m('p', t(`reason_${row.reason}`)), m('p', row.description),
        m('p', row.review_note),
        row.status === 'pending' && m('div', [
          m('textarea.FormControl', { 'aria-label': t('review_note'), value: this.notes[row.id] || '', maxlength: 2000,
            oninput: event => { this.notes[row.id] = event.target.value; } }),
          ...['close', 'delete_message'].map(action => Button.component({ className: 'Button', disabled: !!this.busy,
            onclick: () => this.resolve(row, action) }, t(action))),
        ]),
      ])),
      Button.component({ className: 'Button', disabled: this.offset === 0 || this.loading || !!this.busy,
        onclick: () => { this.offset = Math.max(0, this.offset - 50); this.load(); } }, t('previous')),
      Button.component({ className: 'Button', disabled: this.rows.length < 50 || this.loading || !!this.busy,
        onclick: () => { this.offset += 50; this.load(); } }, t('next')),
    ]);
  }
}
